import React, {useContext, useEffect, useMemo } from 'react'
import { Page, Text, View, Document, PDFViewer, Image, PDFDownloadLink, BlobProvider} from '@react-pdf/renderer';
import { v4 as uuid } from 'uuid';
import UserContext from '../../../context/Globales/UserContext';
import moment from 'moment';

const IcpdfDetallesSociedades = (dato) => {


   
    const { datoIC } = useContext(UserContext);
   // console.log(dato.dato.dataSociedades.TipoPublicacion);
    
 moment.locale('spanish');
 const Fecha = moment('').format('LLLL')
    
    const IndentificacionTipoPublicacion = (

        <View style={{ fontSize: 9 }}>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Tipo de Publicación:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{dato.dato.dataSociedades.TipoPublicacion}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }}>
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Fecha de Públicación:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{dato.dato.dataSociedades.FechaPublicacion}</Text>
            </View>
         

         </View>
     
    ); 

    const IdentificacionSociedades = (
        <>
        {dato.dato.dataSociedades.Detalles.map((d, id)=>(
            <View style={{ fontSize: 9 }} key={id}>
            <View style={{ flexDirection: 'row', fontSize: 9 }}  >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Rut:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.Rut}</Text>
            </View>
            <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Fecha de Escritura:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.FechaEscritura}</Text>
          
          </View>

          <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Fecha de Constitución:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.FechaDeConstitucion}</Text>
          
          </View>
          <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Nombre de Fantasia:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.NombreDeFantasia}</Text>
          
          </View>

          <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Constituidad como:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.ConstituidaComo}</Text>
          
          </View>

          
          <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Fecha de Termino:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.FechaDeTermino}</Text>
          
          </View>

          <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Capital Suscrito (peso):</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.CapitalSuscrito}</Text>
          
          </View>

          <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Capital pagado (peso):</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.CapitalPagado}</Text>
          
          </View>

          <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Acciones:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.NumeroDeAcciones}</Text>
          
          </View>

          <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Localidad Registro comercio:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{d.CiudadNotario}</Text>
          
          </View>

          <View style={{ flexDirection: 'row', fontSize: 9 }} >
                <Text style={{ padding: '2,15', width: '30%', backgroundColor: "#f5f5f5", borderBottom: '1 solid #bbdefb', fontWeight: 'bold' }}>Codigo Extracto:</Text>
                <Text style={{ padding: '2,15', width: '70%', textAlign: 'left', borderBottom: '1 solid #bbdefb' }}>{dato.dato.dataSociedades.Extracto}</Text>
          
          </View>

          </View>
            ))}
</>
    ); 

    const TblDetalleSocio =(

            <>
               

                <View style={{ width: '100%' }}>     
                <View style={{ flexDirection: 'row', fontSize: 9, backgroundColor: '#e6e6e6', color: 'black' }}>

                <Text style={{ width: '5%', height: '25px', padding: '1,10', textAlign: 'center' }}>#</Text>
                <Text style={{ width: '15%', height: '25px', textAlign: 'center' }}>Rut.</Text>
                <Text style={{ width: '30%', height: '25px', textAlign: 'left' }}>Nombre</Text>
                <Text style={{ width: '20%', height: '25px', textAlign: 'center' }}>Motivo</Text>
                <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>Aporte</Text>
                <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>Moneda</Text>
                <Text style={{ width: '10%', height: '25px', textAlign: 'center' }}>Porcentaje</Text>

                </View>


                {dato.dato.dataSociedades.Detalles[0].Socios.map((Socios, idsociosdetalle)=>(
                <View style={{ flexDirection: 'row', fontSize: 9 }} key={idsociosdetalle}>
                    <Text style={{ width: '5%', borderBottom: '1 solid #e6e6e6 ', height: '25px', padding: '1,10', textAlign: 'center' }}>{idsociosdetalle + 1}</Text>
                    <Text style={{ width: '15%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{Socios.Rut}</Text>
                    <Text style={{ width: '30%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'left' }}>{Socios.Nombre}</Text>
                    <Text style={{ width: '20%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{Socios.MotivoPublicacion}</Text>
                    <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{Socios.Aporte}</Text>
                    <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{Socios.Meneda}</Text>
                    <Text style={{ width: '10%', borderBottom: '1 solid #e6e6e6 ', height: '25px', textAlign: 'center' }}>{Socios.Porcentaje}%</Text>
                </View>


              ))}    
                </View>
               


            </>
    );



    const ReporteSociedadesdPdf =()=>(
         
        <Document >
            
            <Page size="letter" style={{ paddingTop: 15, paddingBottom: 40, paddingHorizontal: 20 }}>
                <View>


                    <Image src={process.env.PUBLIC_URL + '/static/imagen/logonewp.png'} style={{ width: '100%', padding: '2' }} fixed />
                  
                    <Text style={{ fontSize: 9, textAlign: 'right' }} fixed>FECHA IMPRESIÓN: {Fecha}</Text>
                    <Text style={{ fontSize: 10, textAlign: 'right' }} render={({ pageNumber, totalPages }) => (`PÁGINA ${pageNumber} / ${totalPages}`)} fixed />
                   
                    <View fixed>
                        <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#bbdefb', color: 'black', marginTop: 8, padding: '5,15' }}>{datoIC.Identificacion?.IsEmpresa ? datoIC.DetalleIdentificacionEmpresa?.Nombre : datoIC.Identificacion?.Nombre} RUT {datoIC.Identificacion?.Rut}</Text>
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE  DE LA SOCIEDAD</Text>
                        {IndentificacionTipoPublicacion}
                    </View>
                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}></Text>
                        {IdentificacionSociedades}
                    </View>

                    <View style={{ width: '100%' }}>
                        <Text style={{ width: '100%', textAlign: 'left', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}>DETALLE DE SOCIOS</Text>
                        {TblDetalleSocio}
                    </View>

                    

                 

                    <View style={{ width: '50%', alignContent: 'left' }}>
                        {/*<Image src={process.env.PUBLIC_URL + '/static/imagen/IconoEmpresa/qrPortacheque.png'} style={{ width: '30%', padding: '5' }} />*/}
                    <Text style={{ width: '100%', textAlign: 'center', backgroundColor: '#e6e6e6', color: 'black', marginTop: 8, padding: '5,15', fontSize: '11' }}  >Nro. FOLIO: {datoIC.ID} - {uuid(datoIC.ID)}</Text>
                    </View>


                </View>


            </Page>

        </Document>

    ); 



    
    
    return useMemo(
        ()=>(
        <div>

        
        <PDFDownloadLink  document={<ReporteSociedadesdPdf />} fileName={`${uuid()}.pdf`}>

        {({ blob, url, loading, error }) => (loading ? <h2 style={{ textAlign: 'center', fontSize: '18px' }}>Ten paciencia, estamos generando el PDF... </h2> : <h2 style={{ textAlign: 'center', fontSize: '22px' }}>DESCARGAR ARCHIVO PDF</h2>)}
          
        </PDFDownloadLink>
            
           

        </div>
    ),[]
    
);
}

export default IcpdfDetallesSociedades
